import { Link } from "react-router-dom";
import { Home, ArrowLeft, Search } from "lucide-react";

export default function NotFoundPage() {
  return (
    <main className="max-w-5xl mx-auto px-6 py-20 text-center" data-testid="not-found-page">
      <div className="text-[120px] sm:text-[180px] font-extrabold leading-none text-orange-500 select-none">
        404
      </div>
      <h1 className="font-display text-3xl sm:text-4xl font-extrabold tracking-tight mt-2">
        Page introuvable
      </h1>
      <p className="text-[var(--ink-soft)] mt-3 max-w-md mx-auto">
        Cette page n&apos;existe pas ou a ete deplacee. Pas de panique, continuons votre exploration de Fodindin.
      </p>
      <div className="flex flex-wrap justify-center gap-3 mt-8">
        <Link to="/" className="btn-primary inline-flex items-center gap-2" data-testid="404-home">
          <Home size={14} /> Retour a l&apos;accueil
        </Link>
        <Link to="/annonces" className="btn-secondary inline-flex items-center gap-2" data-testid="404-annonces">
          <Search size={14} /> Voir les annonces
        </Link>
        <button onClick={() => window.history.back()} className="btn-secondary inline-flex items-center gap-2" data-testid="404-back">
          <ArrowLeft size={14} /> Page precedente
        </button>
      </div>
    </main>
  );
}
